"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateIntegrations = void 0;
var browser_1 = require("@splitsoftware/splitio-commons/cjs/utils/constants/browser");
var configurable_1 = require("@splitsoftware/splitio-commons/cjs/utils/settingsValidation/integrations/configurable");
function validateIntegrations(settings) {
    return (0, configurable_1.validateConfigurableIntegrations)(settings, [browser_1.GOOGLE_ANALYTICS_TO_SPLIT, browser_1.SPLIT_TO_GOOGLE_ANALYTICS]);
}
exports.validateIntegrations = validateIntegrations;
